import KpExemplarStatuses from './KpExemplarStatuses.svelte';

export default class ExemplarStatusesController {
    public exemplarStatusesComponent = KpExemplarStatuses;
}
